jQuery(function($) {
	"use strict"

	// Helpers for accessing the mobile/desktop state of the site
	var MAX_MOBILE_SCREEN_WIDTH = 1024; // const not allowed in strict mode
	var isMobile = ( function() {
		return window.innerWidth <= MAX_MOBILE_SCREEN_WIDTH;
	});
	var isDesktop = ( function() {
		return !isMobile();
	});

	//When all jQuery selectors are found, execute a call-back.
	//  Call-back is given first selector's result as context (this)
	//  and all selectors' as arguments.
	//
	//  when('.class-a', '.class-b', function(a, b) {
	//    console.log('Total found:', a.length + b.length)
	//  })
	var when = function() {
		var selectors = Array.prototype.slice.apply(arguments),
			cb = selectors.pop(),
			jq = [];

		for(var i = 0; i < selectors.length; i++) {
			var $sel =  $(selectors[i]);
			if(!$sel.length) return;
			jq.push($sel);
		}

		return cb.apply(jq[0],jq);
	}

	//Toggles blog comment form when clicking the title
	//or a reply link
	$('#reply-title').click(function(){
		$('#commentform').slideToggle(300)
	});

	$('.comment-reply-link').click(function(){
		$('#commentform').slideDown(300);
	});

	//Mobile Menu Script
	/*var menuOpen = false;
	$('#mobile-menu-button').click(function(){
		if(!menuOpen){
			$('#mobile-menu-wrap, html, #mobile-menu-button').addClass('mobile-menu-open');
			menuOpen = true;
		}else{
			$('#mobile-menu-wrap, html, #mobile-menu-button').removeClass('mobile-menu-open');
			menuOpen = false;
		}
	});
	$(document).bind('touchstart click', function(e)
	{
		var container = $("#mobile-menu-wrap");
		var menuButton = $("#mobile-menu-button");
		var menuButtonBars = $(".menu-button-bar")

		if (!container.is(e.target) && !menuButton.is(e.target) && !menuButtonBars.is(e.target)
			&& menuButton.has(e.target).length === 0
			&& container.has(e.target).length === 0)
		{
			$('#mobile-menu-wrap, html, #mobile-menu-button').removeClass('mobile-menu-open');
			menuOpen = false;
		}
	});

	//This handles toggling sub-menus
	$('#mobile-menu-wrap li.menu-item-has-children').click(function(){
		$(this).find('.sub-menu').slideToggle(300);
	});

	//Function that sets the height of the mobile menu and controls/handles scrolling
	//if the menu is too tall for the viewport
	var setMobileMenuHeight = function(){
		var windowHeight = $(window).height();
		var documentHeight = $(document).height();
		$('#mobile-menu-wrap').height(documentHeight);
		//Adjust the tailing number below (currently 25) to control distance between the
		//bottom of the window and the bottom of the mobile menu
		$('#mobile-menu-interior-wrap').css('max-height',windowHeight - 25);
	};
	setMobileMenuHeight();
	$(window).resize(setMobileMenuHeight);*/




	// Sets height of all grid elements based on width of container
	( function() {
		var resizeElementGrid = function() {
			var elementHeight = isMobile() ?
				$(".event-grid.mobile .event-grid-square").first().width() :
				$(".event-grid.desktop .event-grid-square").first().width();
			var elements = isMobile() ?
				$(".event-grid.mobile .event-grid-row").children() :
				$(".event-grid.desktop .event-grid-row").children();
			elements.css({"height":elementHeight + "px"});
		};
		$(window).load(function() {
			resizeElementGrid();
		});
		$(window).resize(function() {
			resizeElementGrid();
		});
		resizeElementGrid();
	})();

	// Makes rollover grid images funtion like links
	( function() {
		$(".event-grid-square, .event-grid-rectangle").on("click", function() {
			window.location = "/festival-events";
		});
	})();

	// Toggle Desktop Search Visibility
	/*( function() {
		var searchButton = $("#desktop-search-button");
		var searchField = $("#desktop-search-field");
		searchButton.click(function() {
			searchField.toggleClass("hidden");
		});
		$(document).bind('touchstart click', function(e)
		{
			if (!searchField.is(e.target)
				&& !searchButton.is(e.target)
				&& searchField.has(e.target).length === 0
				&& !searchField.hasClass("hidden"))
			{
				searchField.addClass("hidden");
			}
		});
	})();*/

	// Show warning message if no dates were found
	( function() {
		if ( !$(".event-day-selector-static").length) {
			$(".events-legend").hide();
			$(".warning-message").fadeIn();
		}
	})();

	// Show overview and faqs on events page based on selected options
	var displayDateOverview = function() {
		var dateSelection = $(".event-day-selector-static li.active");
		var dateSelectionId = $(dateSelection).attr('id');
		var dateIndex = dateSelectionId.substr(dateSelectionId.lastIndexOf('-') + 1, dateSelectionId.length);
		var queryString = ".festival-date-index-" + dateIndex;
		$('.festival-date-overview').fadeOut().promise().done(function() {
			$('.faq-answer').hide();
			$(".festival-date-overview" + queryString).fadeIn();
		});
	}

	// Show table based on selected options
	var displayEventTable = function() {
		var dateSelection = $(".event-day-selector-static li.active");
		var dateSelectionId = $(dateSelection).attr('id');
		var dateIndex = dateSelectionId.substr(dateSelectionId.lastIndexOf('-') + 1, dateSelectionId.length);
		var communityClassString = $(".events-legend .radio-buttons input:checked").attr("id");
		communityClassString = communityClassString.substr(6, communityClassString.length);
		var queryString = ".events-table tr.festival-date-index-" + dateIndex;
		if (communityClassString == "both") {
			queryString = queryString + ".both, "
				+ queryString + ".menasha, "
				+ queryString + ".neenah";
		} else {
			queryString = queryString + "." + communityClassString;
		}
		$(".warning-message").fadeOut(250);
		$(".events-table tr td").removeClass("active");
		$(".events-table tr.faq-answer").hide();
		$("tbody").fadeOut(300, function() {
			$(".events-table tr").removeClass("visible").removeClass("even");
			$(queryString).addClass("visible").filter(":odd").addClass("even");
			if ( $(queryString).length == 0 ) {
				$(".warning-message").fadeIn();
			}
		}).fadeIn(300);
	};

	// Radio Button Event selectors
	( function() {
		var bothButton = $("#radio-both");
		$(".events-legend .radio-buttons input").on('click', function() {
			if ( $(this).attr("selected")) {
				return;
			}
			displayEventTable();
		});
	})();

	// Date Selector Event selectors
	( function() {
		var dateSelectors = $(".event-day-selector-static li, .event-day-selector-fixed li");
		dateSelectors.on("click", function() {
			if ( !$(this).hasClass("active")) {
				dateSelectors.removeClass('active');
				var linkId = $(this).attr('id');
				var index = linkId.substr(linkId.length-1, linkId.length)
				var linkClass = ".day-button-" + index;
				$(linkClass).addClass("active");
				displayEventTable();
				displayDateOverview();
			}
		});
		dateSelectors.first().click();
	})();

	// Fixed "Sticky" Header on home and regular header for interior pages
	(function () {
		var fixedDateSelector = $(".event-day-selector-fixed");
		if (!fixedDateSelector.length) {
			return;
		}
		var staticDateSelector = $(".event-day-selector-static");
		fixedDateSelector.hide();
		$(window).on('scroll', function() {
			if (isMobile()) { return; }
			var position = $(window).scrollTop();
			var staticDateSelectorBottom = staticDateSelector.offset().top + staticDateSelector.height();
			if( position > staticDateSelectorBottom) {
				fixedDateSelector.fadeIn();
			} else {
				fixedDateSelector.fadeOut();
			}
		});
		$(window).on('resize', function() {
			if (isMobile()) {
				fixedDateSelector.hide();
			}
		});
	})();


	// FAQs
	( function() {
		var faqAnswers = $(".faq-answer");
		faqAnswers.hide();
		var faqQuestions = $(".faq-question, .faq-question-small");
		faqQuestions.on("click", function(){
			var faqId = $(this).attr("id");
			var faqIndex = faqId.substr(faqId.lastIndexOf('-') + 1, faqId.length);
			const self = $(this);
			self.toggleClass('active');
			const details = $("#faq-answer-" + faqIndex);
			if (self.hasClass('active'))
				details.hide();
			details.slideToggle(200);
		});
	})();


	// Slider - Different Version for Mobile vs Desktop
	/*( function() {
		var slider = $('#sponsors .slides');
		var numSlides = $('#sponsors .slides .slide').size();
		var isMobileSlider = false;
		var initMobileSlider = function () {
			slider.slick({
				arrows: false,
				autoplay: true,
				slidesToShow: 1,
			});
			isMobileSlider = true;
		}
		var initDesktopSlider = function () {
			slider.slick({
				autoplay: true,
				arrows: true,
				nextArrow: "#sponsors .right-arrow",
				prevArrow: "#sponsors .left-arrow",
				slidesToShow: 1,
				centerMode: true,
				variableWidth: true,

			});
			isMobileSlider = false;
		}
		if ( isMobile() ) {
			initMobileSlider();
		} else {
			initDesktopSlider();
		}
		var initSlider = function() {
			if (isMobile() && !isMobileSlider) {
				slider.slick('unslick');
				initMobileSlider();
			} else if ( isDesktop() && isMobileSlider) {
				slider.slick('unslick');
				initDesktopSlider();
			}
		}
		$(window).resize(function() {
			initSlider();
		});
	})();

	//Headline Animation
	(function() {
		var words = $("#headline span");
		var showWords = function() {
			setTimeout(function() {
				words.eq(0).removeClass("hidden");
			}, 500);
			setTimeout(function() {
				words.eq(1).removeClass("hidden");
			}, 1000);
			setTimeout(function() {
				words.eq(2).removeClass("hidden");
			}, 1500);
		};
		$(window).load(function() {
			showWords();
		});
	})();


	$('body').fadeIn(1000);*/


	/*
	function initMaps() {
		if (!$("#map").length) {
			return
		};
		// Settings
		var vendorMarkerFontSize = 20;
		var vendorColorActivity = "#12add4";
		var vendorColorEntertainment = "#19a930";
		var vendorColorFood = "#dc7418";

		// JQuery Selections

		var riversideLink = $("#map-menu .riverside-link");
		var jeffersonLink = $("#map-menu .jefferson-link");
		var paradeLink = $("#map-menu .parade-link");

		var activityLink = $("#legend h4.activity-legend");
		var entertainmentLink = $("#legend h4.entertainment-legend");
		var foodLink = $("#legend h4.food-legend");
		var mapDiv = $("#map");
		// Variables
		var map;
		var activityMarkers = new Array();
		var entertainmentMarkers = new Array();
		var foodMarkers = new Array();

		riversideLink.on("click", function() {
			riversideLink.addClass("active");
			jeffersonLink.removeClass("active");
			paradeLink.removeClass("active");
			map.panTo({lat: 44.181875, lng: -88.448175});
			isMobile() ? map.setZoom(16) : map.setZoom(17);
		})
		jeffersonLink.on("click", function() {
			riversideLink.removeClass("active");
			jeffersonLink.addClass("active");
			paradeLink.removeClass("active");
			map.panTo({lat: 44.203264, lng: -88.428668});
			isMobile() ? map.setZoom(16) : map.setZoom(17);
		})
		paradeLink.on("click", function() {
			riversideLink.removeClass("active");
			jeffersonLink.removeClass("active");
			paradeLink.addClass("active");
			map.panTo({lat: 44.193641, lng: -88.451984});
			map.setZoom(14);
		})

		function initMap() {
			map = new google.maps.Map(document.getElementById('map'), {
				center: {lat: 44.181875, lng: -88.448175},
				zoom: 17,
				mapTypeControlOptions: {
					position: google.maps.ControlPosition.RIGHT_TOP,
				},
			});

			var paradeRouteCoordinates = [
				{lat: 44.182231, lng: -88.452777},
				{lat: 44.186462, lng: -88.461600},
				{lat: 44.194391, lng: -88.454337},
				{lat: 44.194666, lng: -88.454210},
				{lat: 44.197605, lng: -88.453273},
				{lat: 44.198091, lng: -88.453223},
				{lat: 44.199444, lng: -88.453209},
				{lat: 44.199466, lng: -88.452755},
				{lat: 44.200964, lng: -88.449052},
				{lat: 44.201073, lng: -88.449124},
				{lat: 44.201143, lng: -88.449154},
				{lat: 44.201219, lng: -88.449169},
				{lat: 44.202031, lng: -88.449171},
			];
			var paradeRoute = new google.maps.Polyline({
				path: paradeRouteCoordinates,
				geodesic: true,
				strokeColor: '#12add4',
				strokeOpacity: 1.0,
				strokeWeight: 4
			});
			paradeRoute.setMap(map);

			var roadClosedRouteCoordinates = [
				{lat: 44.180077, lng: -88.448292},
				{lat: 44.182231, lng: -88.452777},
			];
			var roadClosedRoute = new google.maps.Polyline({
				path: roadClosedRouteCoordinates,
				geodesic: true,
				strokeColor: '#ff3535',
				strokeOpacity: 1.0,
				strokeWeight: 6
			});
			roadClosedRoute.setMap(map);

			addLabels(map, window.cfsData["map_labels"]);

			populateFoodVendorLabels(foodMarkers, window.cfsData["food_locations"]);
			setMapOnMarkers(map, foodMarkers);

			populateEntertainmentVendorLabels(entertainmentMarkers, window.cfsData["entertainment_locations"]);
			setMapOnMarkers(map, entertainmentMarkers);

			populateActivityVendorLabels(activityMarkers, window.cfsData["activity_locations"]);
			setMapOnMarkers(map, activityMarkers);



		};

		activityLink.on("click", function() {
			$(this).toggleClass("active");
			var mapVar = $(this).hasClass("active") ? map : null;
			setMapOnMarkers(mapVar, activityMarkers);
		});
		entertainmentLink.on("click", function() {
			$(this).toggleClass("active");
			var mapVar = $(this).hasClass("active") ? map : null;
			setMapOnMarkers(mapVar, entertainmentMarkers);
		});
		foodLink.on("click", function() {
			$(this).toggleClass("active");
			var mapVar = $(this).hasClass("active") ? map : null;
			setMapOnMarkers(mapVar, foodMarkers);
		});

		initMap();
		$("#map-menu .riverside-link").click();

		function addLabels(map, objs) {
			for(var key in objs) {
				addLabel(map, objs[key]);
			}
		}

		function populateActivityVendorLabels(arr, objs) {
			for(var key in objs) {
				arr.push (getVendorLabel(objs[key], "A", vendorColorActivity));
			}
		}
		function populateEntertainmentVendorLabels(arr, objs) {
			for(var key in objs) {
				arr.push (getVendorLabel(objs[key], "E", vendorColorEntertainment));
			}
		}
		function populateFoodVendorLabels(arr, objs) {
			for(var key in objs) {
				arr.push (getVendorLabel(objs[key], "F", vendorColorFood));
			}
		}

		function addLabel(map, obj) {
			var lat = obj["latitude"];
			var lng = obj["longitude"];
			var text = obj["label"];
			var fontSize = obj["large"] ? 18 : 12;
			var strokeWeight = obj["large"] ? 0 : 3;
			var mapLabel = new MapLabel({
				text: text,
				position: new google.maps.LatLng(lat, lng ),
				map: map,
				fontSize: fontSize,
				fontColor: 'black',
				align: 'center',
				strokeWeight: strokeWeight,
				zIndex: 5
			});
			mapLabel.set('position', new google.maps.LatLng(lat, lng));
		}

		function setMapOnMarkers(map, markers) {
			for (var i = 0; i < markers.length; i++) {
				markers[i].setMap(map);
			}
		}

		function getVendorLabel(obj, text, color) {
			var lat = obj["latitude"];
			var lng = obj["longitude"];
			var mapLabel = new MapLabel({
				text: text,
				position: new google.maps.LatLng(lat, lng ),
				fontSize: vendorMarkerFontSize,
				fontColor: color,
				align: 'center',
			});
			mapLabel.set('position', new google.maps.LatLng(lat, lng));
			return mapLabel;
		}


	}

	google.maps.event.addDomListener(window, "load", initMaps);*/

});